export default __webpack_public_path__ + "static/media/schedule-new.17a0f6c8.svg";